import React from 'react';

interface TooltipProps {
  text: string;
  children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
  return (
    <div className="relative group">
      {children}
      <span className="absolute min-w-[220px] bottom-full left-1/2 -translate-x-1/2 mb-2 text-center px-3 py-1.5 text-xs font-medium text-white bg-gray-900 rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
        {text}
      </span>
    </div>
  );
};

export default Tooltip;
